import React from "react";
import { motion } from "framer-motion";

const HERO_IMG =
  "https://images.unsplash.com/photo-1541512416146-3cf58d6b27cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGFydCUyMGJsYWNrJTIwYW5kJTIwd2hpdGV8ZW58MHx8fHwxNzgxNTY0OTgzfDA&ixlib=rb-4.1.0&q=85";

const fade = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.2 + i * 0.15 },
  }),
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full bg-white overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 pt-36 md:pt-48 pb-24 md:pb-32 grid grid-cols-12 gap-6 md:gap-10">
        {/* Left column: text */}
        <div className="col-span-12 md:col-span-7 flex flex-col justify-end">
          <motion.span
            initial="hidden"
            animate="show"
            custom={0}
            variants={fade}
            className="label mb-8 md:mb-12"
          >
            NYG Projects — Est. 2025
          </motion.span>

          <motion.h1
            initial="hidden"
            animate="show"
            custom={1}
            variants={fade}
            className="font-heading text-[44px] sm:text-6xl md:text-7xl lg:text-[110px] leading-[0.95] tracking-[-0.02em] text-black"
          >
            Where Art
            <br />
            Becomes
            <br />
            <span className="italic font-light">Encounter.</span>
          </motion.h1>

          <motion.p
            initial="hidden"
            animate="show"
            custom={2}
            variants={fade}
            className="font-body font-light text-base md:text-lg lg:text-xl text-black/70 mt-10 md:mt-14 max-w-xl leading-relaxed"
          >
            Intimate pop-up exhibitions shaped by place, connection and experience.
          </motion.p>
        </div>

        {/* Right column: image */}
        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
          className="col-span-12 md:col-span-5 relative h-[280px] md:h-auto md:min-h-[400px]"
        >
          <div className="absolute inset-0 overflow-hidden">
            <img
              src={HERO_IMG}
              alt="Abstract artwork"
              className="img-mono w-full h-full object-cover"
              data-testid="hero-image"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 hidden md:block">
            <span className="label bg-white px-3 py-2">Vol. 01</span>
          </div>
        </motion.div>
      </div>

      {/* Scroll cue */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4, duration: 1 }}
        className="absolute bottom-8 left-6 md:left-12 lg:left-16 flex items-center gap-4"
      >
        <div className="w-12 h-px bg-black" />
        <span className="label">Scroll</span>
      </motion.div>
    </section>
  );
}
